import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-17e602a8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "order_types" };
import { ref } from 'vue';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    emits: ["click"],
    setup(__props, { emit }) {
        const selectValue = ref('Limit');
        const { format, ORDER } = useMessage();
        const onClick = (value) => {
            selectValue.value = value;
            emit('click', value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", {
                    class: _normalizeClass([selectValue.value === 'Limit' ? 'select' : '', "order_types_content"]),
                    onClick: _cache[0] || (_cache[0] = ($event) => (onClick('Limit')))
                }, _toDisplayString(_unref(format)(_unref(ORDER).LIMIT)), 3),
                _createElementVNode("span", {
                    class: _normalizeClass([selectValue.value === 'Market' ? 'select' : '', "order_types_content"]),
                    onClick: _cache[1] || (_cache[1] = ($event) => (onClick('Market')))
                }, _toDisplayString(_unref(format)(_unref(ORDER).MARKET)), 3)
            ]));
        };
    }
});
